/*global localStorage*/
import moment from 'moment';
import { t } from 'i18next'

var getDaysArray = (dateP) => {
	let month = dateP.split('/')[1];
	let year = dateP.split('/')[2];

	var monthIndex = month - 1;
	var date = new Date(year, monthIndex, 1);
	var result = [];
	while (date.getMonth() == monthIndex) {
		let day = `${((date.getDate() < 10) && ("0"+date.getDate())) || ""+date.getDate()}/${(((date.getMonth()+1) < 10) && ("0"+(date.getMonth() + 1))) || ""+(date.getMonth() + 1)}/${date.getFullYear()}`;
		result.push(day);
		date.setDate(date.getDate() + 1);
	}
	return result;
};

function generateScenarioEvents(novaTabela, id_motivo, ds_motivo) {
	const eventos = [];
	
	for (let i = 0; i < novaTabela.length; i++) {
	  const newDia = novaTabela[i];
	  if (!newDia) continue;

	  const newCols = newDia.colunas;
  
	  for (const colId in newCols) {
		const newCol = newCols[colId];
		if (!newCol) continue;
  
		if (!newCol._meta || !newCol._meta.alterado || !newCol._meta.is_new || !newCol._meta.oldJson) continue;
		delete newCol._meta.is_new;
		const newJson = {
		  id_prato: newCol.id_prato,
		  vlr_custo_percapita: newCol.vlr_custo_percapita,
		  perc_consumo: newCol.perc_consumo,
		  vr_pu_dia: newDia.vr_pu_dia
		};
  
		eventos.push({
		  idAcao: newCol._meta.id_acao || null,
		  idOrigem: newCol._meta.id_origem || null,
		  dtCardapio: newDia.data,
		  idColuna: newCol.id_coluna,
		  idMotivo: id_motivo || null,
		  dsMotivo: ds_motivo || null,
		  oldJson: newCol._meta.oldJson,
		  newJson
		});
	  }
	}
	return eventos;
};

const Calc_comensais_acumulado_div = function(tabela, dateIndex){
	if (!tabela || !tabela.length || dateIndex > tabela.length ) return null;

	if (tabela[dateIndex].qtde_comensais_acumulado_div) return tabela[dateIndex].qtde_comensais_acumulado_div;
	
	let qtde_comensais_acumulado_div = 0;
	for (let i = 0; i <= dateIndex; i++) {
		qtde_comensais_acumulado_div += tabela[i].comensais_detalhe.comensais_divisao;
	}
	return qtde_comensais_acumulado_div;
}

const updateRemainingPU = function(tabela, dateIndex){
	const startIndex = dateIndex;
  	if (startIndex === -1) return dataCatalog;
	let dia = tabela[startIndex];
	let custo_acumulado = dia.vr_pu_detalhe.vr_custo_total_acumulado;

	for (let i = startIndex + 1; i < tabela.length; i++) {
		const cur_dia = tabela[i];
		custo_acumulado += cur_dia.vr_pu_detalhe.vr_custo_total_dia;
		cur_dia.vr_pu_detalhe.vr_custo_total_acumulado = custo_acumulado;
		cur_dia.vr_pu_acumulado = custo_acumulado / (Calc_comensais_acumulado_div(tabela, i) || 1);
	}
}

const updateCurrentPU = function(dia, tabela, startIndex, pratos) {
	// 1) Custo total do dia
	let vr_custo_total_dia = dia.colunas.reduce((acc, col) => {
		const preco = parseFloat(pratos[col.id_prato]?.vlr_prato || 0);
		return acc + preco * ((col.perc_consumo / 100) * dia.qtde_comensais);
	}, 0);

	// 2) Custo acumulado
	const custo_anterior = tabela[startIndex - 1]?.vr_pu_detalhe?.vr_custo_total_acumulado || 0;
	const custo_acumulado = custo_anterior + vr_custo_total_dia;
	const com_div = parseFloat(dia.comensais_detalhe?.comensais_divisao || 1);

	// 3) Quantidade acumulada
	const qtde_acumulada = Calc_comensais_acumulado_div(tabela, startIndex) || 1;

	// 4) Atualiza o dia
	dia.vr_pu_detalhe.vr_custo_total_dia = vr_custo_total_dia;
	dia.vr_pu_detalhe.vr_custo_total_acumulado = custo_acumulado;

	dia.vr_pu_dia = vr_custo_total_dia / com_div;
	dia.vr_pu_acumulado = custo_acumulado / qtde_acumulada;
}

const updateCatalogConsumption = function (dataCatalog, dateIndex, id_Coluna, old_vr_perc_consumo) {
	const tabela = dataCatalog.tabela;
	const pratos = dataCatalog.pratos;
	const startIndex = dateIndex;

	if (startIndex === -1) return dataCatalog;

	const dia = tabela[startIndex];
	const coluna = dia.colunas.find(c => c.id_coluna === id_Coluna);
	if (!coluna || !dia.qtde_comensais || !coluna.id_prato) return dataCatalog;

	const com_div = parseFloat(dia.comensais_detalhe?.comensais_divisao || 1);
	const oldJson = {
		id_prato: coluna.id_prato,
		vlr_custo_percapita: coluna.vlr_custo_percapita,
		perc_consumo: old_vr_perc_consumo,
		vr_pu_dia: dia.vr_pu_dia
		};

	if (coluna._meta) {
		oldJson.id_acao_old = coluna._meta.id_acao;
		oldJson.id_origem_old = coluna._meta.id_origem;
	}

	coluna.vlr_custo_percapita =
		(parseFloat(pratos[coluna.id_prato]?.vlr_prato || 0) *
			((coluna.perc_consumo / 100) * parseFloat(dia.qtde_comensais))) / com_div;

	coluna._meta = { alterado: true, id_origem: 'usuario', id_acao: 'ajuste_consumo', is_new: true, oldJson };

	// Atualiza PU do dia
	updateCurrentPU(dia, tabela, startIndex, pratos);

	// Atualiza dias seguintes
	updateRemainingPU(tabela, startIndex);

	return dataCatalog;
};


function updateCopiaComenais(dataCatalog, coluna, exceptions, pickedRadioChoice){
	const tabela = dataCatalog.tabela;
	if(!tabela || !coluna) return dataCatalog;
	//percorre os dias na coluna indicada trocando o percentual de consumo (percentual ou comensais)
	for (let i = 0; i < tabela.length; i++) {
		
		const dia = dataCatalog.tabela[i];
		const colunaDia = dia.colunas.find(c => c.id_coluna === coluna.id_coluna);
		
		if(!colunaDia.id_prato || dia.qtde_comensais === 0) continue;

		let keyException;
		if (dia.id_feriado) { // verificando se é feriado
			keyException = "holiday";
		} else {
			keyException = moment(dia.data, "DD/MM/YYYY").locale('en-US').format('dddd').toLowerCase(); // obtém o dia da semana e forma a key (ex: "monday")
		}

		if (!exceptions.hasOwnProperty(keyException)) continue;
		const exceptionValue = parseFloat(exceptions[keyException]);

		const old_vr_perc_consumo = colunaDia.perc_consumo;
		// se for porcentagem utiliza o valor diretamente
		if (pickedRadioChoice === "percent") {
			colunaDia.perc_consumo = exceptionValue;

		// se for valor absoluto converte para porcentagem utilizando o total de comensais
		} else if (dia.qtde_comensais) {
			const totalComensaisDesseDia = parseFloat(dia.qtde_comensais);
			colunaDia.perc_consumo = (exceptionValue / totalComensaisDesseDia) * 100;
		}
		// atualiza o prato chamando o método updateCatalogConsumption
		updateCatalogConsumption(dataCatalog, i, colunaDia.id_coluna, old_vr_perc_consumo)
	}
	return dataCatalog;
}

const getPlateUtilization = function(day, id_grupo, id_feriado, utilizacao_grupo) {
    const group = utilizacao_grupo[id_grupo];
    if (!group) return "P";

    const m = moment(day, "DD/MM/YYYY");
    const weekday = m.day();
    const dayOfMonth = m.date();
    const month = m.month();
    const year = m.year();
    const daysInMonth = m.daysInMonth();

    const firstDay = moment({ year, month, day: 1 });
    const firstWeekday = firstDay.day();

    const offset = (weekday - firstWeekday + 7) % 7;
    const firstOccurrenceDate = 1 + offset;

    let occurrence = Math.floor((dayOfMonth - firstOccurrenceDate) / 7) + 1;

    const isLastOcc = dayOfMonth + 7 > daysInMonth;
    if (isLastOcc && occurrence > 4) {
        occurrence = 5; 
    }

    const weekdayMap = {
        0: "id_domingo",
        1: "id_segunda",
        2: "id_terca",
        3: "id_quarta",
        4: "id_quinta",
        5: "id_sexta",
        6: "id_sabado"
    };

    const weekdayKey = weekdayMap[weekday];
    const weekdayValue = group[weekdayKey] ?? "P";

    let occurrenceValue = "P";
    if (occurrence >= 1 && occurrence <= 4) {
        const key = "id_semana_" + occurrence;
        occurrenceValue = group[key] ?? "P";
    } else {
        occurrenceValue = group["id_ult_semana"] ?? "P";
    }

    const lastOccValue = group["id_ult_semana"] ?? "P";
    const holidayValue = group["id_feriado"] ?? "P";

    if (id_feriado === true && holidayValue !== "P") {
        return holidayValue;
    }

    if (isLastOcc && lastOccValue !== "P") {
        return lastOccValue;
    }

    if (occurrenceValue !== "P") {
        return occurrenceValue; 
    }

    return weekdayValue;
}

const isAlterada = (col) =>
	col._meta?.id_origem === "usuario" &&
	col._meta?.id_acao === "ajuste_consumo";

const setConsumo = (col, valor, ctx, vlr_prato) => {
	const novo = +parseFloat(valor).toFixed(5);
	const atual = +parseFloat(col.perc_consumo || 0).toFixed(5);

	if (novo === atual) return;

	const oldJson = {
		id_prato: col.id_prato,
		vlr_custo_percapita: col.vlr_custo_percapita,
		perc_consumo: atual,
		vr_pu_dia: ctx.vr_pu_dia
		};

	if (col._meta) {
		oldJson.id_acao_old = col._meta.id_acao;
		oldJson.id_origem_old = col._meta.id_origem;
	}

	col.perc_consumo = novo;
	col.vlr_custo_percapita = ((vlr_prato || 0) * ((novo / 100) * ctx.comensais)) / ctx.divisao;

	if (!col._meta?.is_new) {
		col._meta = {
			alterado: true,
			id_origem: "automatico",
			id_acao: "ajuste_consumo",
			is_new: true,
			oldJson
		};
	}
};

/* 🔹 1. calcular base */
const calcularBase = (cols, colunas, pratos, atratividade) => {
	let perc_fixo = 0;
	let perc_historico = 0;
	let peso_total = 0;

	for (const col of cols) {
		const info = colunas[col.id_coluna];
		const prato = pratos[col.id_prato];

		const alterada = isAlterada(col);
		const fixo = info.vr_percentual_fixo;

		if (fixo || alterada) {
			perc_fixo += alterada ? col.perc_consumo : fixo || 0;
			continue;
		}

		if (info.id_tipo_coluna === "HISTORICO") {
			perc_historico += col.perc_consumo || 0;
			continue;
		}

		if (info.id_tipo_coluna === "ATRATIVIDADE") {
			const peso =
				atratividade[prato?.id_atratividade]?.vr_peso || 0;
			peso_total += peso;
		}
	}

	return { perc_fixo, perc_historico, peso_total };
};

/* 🔹 2. distribuir atratividade + aplicar fixos */
const distribuirAtratividade = (
	cols,
	colunas,
	pratos,
	atratividade,
	ctx,
	base,
	perc_conjunto
) => {
	const usado = base.perc_fixo + base.perc_historico;

	const saldo = perc_conjunto
		? Math.max(0, perc_conjunto - usado)
		: Math.max(0, 100 - usado);

	let acumulado = 0;

	for (const col of cols) {
		const info = colunas[col.id_coluna];
		const prato = pratos[col.id_prato];

		const alterada = isAlterada(col);
		const fixo = info.vr_percentual_fixo;

		// fixo
		if (fixo && !alterada) {
			setConsumo(col, fixo, ctx, prato.vlr_prato);
			continue;
		}

		// atratividade
		if (
			info.id_tipo_coluna === "ATRATIVIDADE" &&
			base.peso_total > 0
		) {
			const peso =
				atratividade[prato?.id_atratividade]?.vr_peso || 0;

			const valor = (peso / base.peso_total) * saldo;

			setConsumo(col, valor, ctx, prato.vlr_prato);
			acumulado += valor;
			continue;
		}

		// outros
		if (!fixo && !alterada) {
			acumulado += col.perc_consumo || 0;
		}
	}

	return acumulado;
};

/* 3. ajuste proporcional final */
const ajustarProporcional = (
	cols,
	colunas,
	pratos,
	ctx,
	base,
	acumulado,
	perc_conjunto
) => {
	if (!perc_conjunto || acumulado === perc_conjunto) return;

	const saldoFinal = perc_conjunto < base.perc_fixo ? perc_conjunto : perc_conjunto - base.perc_fixo;

	if (acumulado <= 0) return;

	for (const col of cols) {
		const info = colunas[col.id_coluna];
		const prato = pratos[col.id_prato];

		const alterada = isAlterada(col);
		const fixo = info.vr_percentual_fixo;

		if (!fixo && !alterada) {
			const valor =
				(col.perc_consumo / acumulado) * saldoFinal;

			setConsumo(col, valor, ctx, prato?.vlr_prato);
		}
	}
};

/* função principal */
const recalculatePercentages = (
	dia,
	colunas,
	id_coluna,
	pratos,
	atratividade
) => {
	const infoBase = colunas[id_coluna];
	const grupo = infoBase.cd_grupo_tipoprato;
	const perc_conjunto = infoBase.vr_perc_conjunto ?? null;

	const ctx = {
		comensais: Number(dia.qtde_comensais),
		divisao: Number(dia.comensais_detalhe?.comensais_divisao || 1),
		vr_pu_dia: dia.vr_pu_dia
	};

	// filtra uma vez só
	const cols = dia.colunas.filter((col) => {
		const info = colunas[col.id_coluna];
		return (
			info.cd_grupo_tipoprato === grupo &&
			col.id_prato
		);
	});

	const base = calcularBase(cols, colunas, pratos, atratividade);

	const acumulado = distribuirAtratividade(
		cols,
		colunas,
		pratos,
		atratividade,
		ctx,
		base,
		perc_conjunto
	);

	ajustarProporcional(
		cols,
		colunas,
		pratos,
		ctx,
		base,
		acumulado,
		perc_conjunto
	);

	return dia;
};

const updateCatalogAnalytics = function (dataCatalog, day, id_coluna, pratoOrigem, pratoNovo) {
    const analytics = dataCatalog.analytics[day] ||= {};
    const coluna = dataCatalog.colunas[id_coluna];
    if (!coluna) return dataCatalog.analytics;

    const tipo = coluna.cd_tipoprato;
    const pratos = dataCatalog.pratos;
	const grupos = dataCatalog.grupos;

    const nrSemana = dataCatalog.tabela.find(t => t.data === day)?.nr_semana;

    const inc = (obj, k) => k && (obj[k] = (obj[k] || 0) + 1);
    const dec = (obj, k) => k && obj[k] && (--obj[k] <= 0 && delete obj[k]);

    const grupo = (root) => root[tipo] ||= {};

    const aplicaAnalytics = (coluna, prato, fn) => {
        if (!prato) return;
		const coluna_fixa = coluna.id_coluna_fixa;
		const id_ignora_modopreparo	 = coluna.id_ignora_modopreparo;
		const id_ignora_cor	 = coluna.id_ignora_cor;
		if(coluna_fixa) return;

		analytics.ingredientes ||= {};
        fn(analytics.ingredientes, prato.id_ingrediente_1);
		fn(analytics.ingredientes, prato.id_ingrediente_2);

        analytics.proteinas ||= {};
        fn(analytics.proteinas, prato.id_proteina);

        analytics.cortes ||= {};
        fn(analytics.cortes, prato.id_tipocorte);

		if(!id_ignora_modopreparo){
			analytics.modos_preparo ||= {};
			fn(grupo(analytics.modos_preparo), prato.id_modopreparo);
		}
		if(!id_ignora_cor){
			analytics.cores ||= {};
			fn(grupo(analytics.cores), prato.cor);
		}
    };

	const aplica_Freq = (obj, isInc) => {
		if (!obj) return;
		const soma = isInc ? 1 : -1;
		obj.qt_utilizado = Math.max(0, (obj.qt_utilizado || 0) + soma);

		if (nrSemana != null) {
			obj.qt_utilizado_sem ||= {};
			obj.qt_utilizado_sem[nrSemana] = (obj.qt_utilizado_sem[nrSemana] || 0) + soma;

			if (obj.qt_utilizado_sem[nrSemana] <= 0) {
				delete obj.qt_utilizado_sem[nrSemana];
			}
		}
	};

	if (pratoOrigem) {
		aplicaAnalytics(coluna, pratos[pratoOrigem], dec);
		aplica_Freq(pratos[pratoOrigem], false);
		aplica_Freq(grupos[pratos[pratoOrigem].id_grupo], false);
	}

	if (pratoNovo) {
		aplicaAnalytics(coluna, pratos[pratoNovo], inc);
		aplica_Freq(pratos[pratoNovo], true);
		aplica_Freq(grupos[pratos[pratoNovo].id_grupo], true);
	}
};

const changeCatalogPlate = function (dataCatalog, dateIndex, id_coluna, pratoOrigem, pratoNovo) {

	if (pratoOrigem === pratoNovo) return dataCatalog;

	const { tabela, pratos, colunas } = dataCatalog;

	const startIndex = dateIndex;
	if (startIndex === -1) return dataCatalog;

	const dia = tabela[startIndex];
	if (!dia?.qtde_comensais) return dataCatalog;

	const day = dia.data;
	const coluna = dia.colunas.find(c => c.id_coluna === id_coluna);
	if (!coluna) return dataCatalog;

	const id_acao =
		pratoOrigem == null ? 'inclusao_prato'
		: pratoNovo == null ? 'exclusao_prato'
		: 'substituicao_prato';

	const oldJson = {
		id_prato: pratoOrigem,
		vlr_custo_percapita: coluna.vlr_custo_percapita,
		perc_consumo: coluna.perc_consumo,
		vr_pu_dia: dia.vr_pu_dia
		};

	if (coluna._meta) {
		oldJson.id_acao_old = coluna._meta.id_acao;
		oldJson.id_origem_old = coluna._meta.id_origem;
	}
	coluna._meta = { alterado: true, id_origem: 'usuario', id_acao, is_new: true, oldJson };

	if (pratoOrigem && !coluna.pratos_disponiveis.includes(pratoOrigem)) {
		coluna.pratos_disponiveis.push(pratoOrigem);
	}
	if (pratoNovo) {
		const idx = coluna.pratos_disponiveis.indexOf(pratoNovo);
		if (idx >= 0) coluna.pratos_disponiveis.splice(idx, 1);
	}	

	const infoPratoNovo = pratoNovo ? pratos[pratoNovo] : null;

	let vlr_prato = null;
	let percConsumo = null;
	let utilizacaoPrato = null;

	if (infoPratoNovo) {
		const comensaisDia = Number(dia.qtde_comensais);
		const divisao = Number(dia.comensais_detalhe?.comensais_divisao || 1);

		percConsumo = infoPratoNovo.perc_consumo ?? 50;
		utilizacaoPrato = getPlateUtilization(day, infoPratoNovo.id_grupo, dia.id_feriado, dataCatalog.utilizacao_grupo);

		vlr_prato = (parseFloat(infoPratoNovo.vlr_prato) * ((percConsumo / 100) * comensaisDia)) / divisao;
	}

	/* ----- Atualiza coluna com os novos valores ----- */
	coluna.id_prato = pratoNovo || null;
	coluna.perc_consumo = percConsumo;
	coluna.utilizacao_prato = utilizacaoPrato;
	coluna.vlr_custo_percapita = vlr_prato;

	/* ----- Recalcula percentuais no dia ----- */
	const diaAtualizado = recalculatePercentages(dia, colunas, coluna.id_coluna, pratos, dataCatalog.atratividade );

	tabela[startIndex] = diaAtualizado;

	// Atualiza PU do dia
	updateCurrentPU(diaAtualizado, tabela, startIndex, pratos);

	/* ----- Atualiza P.U. dos dias seguintes ----- */
	updateRemainingPU(tabela, startIndex);

	/* ----- Atualiza analytics ----- */
	updateCatalogAnalytics(dataCatalog, day, coluna.id_coluna, pratoOrigem, pratoNovo);

	return dataCatalog;
};

const mesmoId = (a, b) => a != null && b != null && String(a) === String(b);
const chaveId = (v) => (v == null || v === '' ? null : String(v));

const collectUsedAttributes = (dia, colunasMap, idColunaAlvo, pratos, baseAttrName, cd_tipoprato = null, is_same_day = true) => {
	const used = new Set();
	const addUsed = (v) => {
		const k = chaveId(v);
		if (k !== null) used.add(k);
	};

	for (const col of dia?.colunas || []) {
		/* quando é o mesmo dia não valida a própria coluna; em dias ant/pos inclui a coluna */
		if (is_same_day && mesmoId(col.id_coluna, idColunaAlvo)) continue;

		const info = colunasMap?.[col.id_coluna];
		if (!info) continue;

		if (info.id_coluna_fixa || info.id_intercala_pratos) continue;

		/* se a validação é por tipo de prato, avalia somente colunas do mesmo tipo */
		if (cd_tipoprato && !mesmoId(info.cd_tipoprato, cd_tipoprato)) continue;
		if (baseAttrName === 'id_modopreparo' && info.id_ignora_modopreparo) continue;
		if (baseAttrName === 'cor' && info.id_ignora_cor) continue;

		const prato = pratos?.[col.id_prato];
		if (!prato) continue;

		if (baseAttrName === 'id_ingrediente') {
			addUsed(prato[`${baseAttrName}_1`]);
			addUsed(prato[`${baseAttrName}_2`]);
		} else {
			addUsed(prato[baseAttrName]);
		}
	}
	return used;
};

function hasCombinationRestriction(dia, id_coluna, id_prato, id_grupo, cd_tipoprato, pratos, restricoes) {

	return (restricoes || []).filter(r => {

		// 1. A regra só vale se a combinação do candidato bater
		const combinaComRegra =
			mesmoId(id_prato, r.id_prato_comb) ||
			mesmoId(id_grupo, r.id_grupo_comb) ||
			mesmoId(cd_tipoprato, r.cd_tipoprato);

		if (!combinaComRegra) return false;

		// 2. Verifica se alguma outra coluna do dia quebra a regra
		return (dia?.colunas || []).some(col => {

			if (mesmoId(col.id_coluna, id_coluna)) return false; // ignora a própria (prato atual da célula)

			const pratoCol = pratos?.[col.id_prato];
			if (!pratoCol) return false;

			return (
				// A) mesmo prato da restrição
				mesmoId(col.id_prato, r.id_prato) ||
				// B) grupo igual ao da restrição
				mesmoId(pratoCol.id_grupo, r.id_grupo)
			);
		});
	});
}

function getPlateValidations(plate, coluna, diaIndex, dataCatalog) {
	if (!plate || !dataCatalog || !coluna || diaIndex == null || diaIndex === -1) return [];

	const id_prato  = plate.id_prato;
	const id_grupo  = plate.id_grupo;
	const id_coluna = coluna.id_coluna;

	const { tabela, pratos, grupos, freq_grupos, freq_pratos, colunas, restricao_combinacao, ingredientes, proteinas, tipocorte, modopreparo, utilizacao_grupo } = dataCatalog;

	if (!id_prato || !id_grupo || !pratos?.[id_prato] || !grupos?.[id_grupo]) return [];

	const dia = tabela?.[diaIndex];
	if (!dia) return [];

	const validations = [];
	const semana = (obj) => obj?.qt_utilizado_sem?.[dia.nr_semana] || 0;
	const add = (cond, msg) => cond && validations.push(msg);
	const isNA = (value) => /^n[\s\/\.]?a$/i.test(String(value ?? '').trim());
	const tem = (set, id) => id != null && set.has(String(id));

	/* prato atual da célula: será substituído, então seu uso é descontado dos contadores (-1 +1) */
	const celulaAtual    = (dia.colunas || []).find(c => mesmoId(c.id_coluna, id_coluna));
	const id_prato_atual = celulaAtual?.id_prato;
	const pratoAtual     = id_prato_atual ? pratos[id_prato_atual] : null;
	const descontoGrupo  = pratoAtual && mesmoId(pratoAtual.id_grupo, id_grupo) ? 1 : 0;
	const descontoPrato  = mesmoId(id_prato_atual, id_prato) ? 1 : 0;

	const prato = pratos[id_prato];
	const id_ingrediente_1 = isNA(ingredientes?.[prato.id_ingrediente_1]?.nm_ingrediente || '') ? null : prato.id_ingrediente_1;
	const id_ingrediente_2 = isNA(ingredientes?.[prato.id_ingrediente_2]?.nm_ingrediente || '') ? null : prato.id_ingrediente_2;
	const id_proteina      = isNA(proteinas?.[prato.id_proteina]?.nm_proteina || '') ? null : prato.id_proteina;
	const id_tipocorte     = isNA(tipocorte?.[prato.id_tipocorte]?.nm_tipocorte || '') ? null : prato.id_tipocorte;
	const id_modopreparo   = isNA(modopreparo?.[prato.id_modopreparo]?.nm_modopreparo || '') ? null : prato.id_modopreparo;
	const cor              = isNA(prato.cor) ? null : prato.cor;

	const { id_coluna_fixa, id_ignora_cor, id_ignora_modopreparo, id_intercala_pratos, cd_tipoprato } = colunas[id_coluna] || {};

	/* 0) custo, inatividade etc. — intrínsecos ao candidato */
	if (prato.custo_problema) {
		(prato.custo_problema_tipos ?? []).forEach((problemType) => {
			add(true, problemType === 'PRATO_INATIVO' ? t(problemType) : `Prato possui ${t(problemType)}`);
		});
	}

	/* 1) frequência de grupo (desconta o prato atual se for do mesmo grupo) */
	const fg = freq_grupos?.[id_grupo];
	if (fg) {
		const g = grupos[id_grupo];
		add((g.qt_utilizado || 0) - descontoGrupo >= fg.qt_max_mes, t('freq_grupo_mes_atingido'));
		add(semana(g) - descontoGrupo >= fg.qt_max_sem,              t('freq_grupo_sem_atingido'));
	}

	/* 2) frequência de prato (desconta se o candidato for o próprio prato atual) */
	const fp = freq_pratos?.[id_prato];
	if (fp) {
		const p = pratos[id_prato];
		add((p.qt_utilizado || 0) - descontoPrato >= fp.qt_max_mes, t('freq_prato_mes_atingido'));
		add(semana(p) - descontoPrato >= fp.qt_max_sem,              t('freq_prato_sem_atingido'));
	}

	/* utilização restrita do grupo no dia */
	add(getPlateUtilization(dia.data, id_grupo, dia.id_feriado, utilizacao_grupo) === 'R',
		t('utilizacao_restrita_grupo', { PARAM: `${grupos[prato.id_grupo]?.nm_grupo}` }));

	/* 3) repetições no mesmo dia (a própria coluna já é ignorada) */
	if (!id_coluna_fixa && !id_intercala_pratos) {

		if ((id_ingrediente_1 || id_ingrediente_2) && ingredientes && ingredientes.length) {
			const set = collectUsedAttributes(dia, colunas, id_coluna, pratos, 'id_ingrediente');
			add(tem(set, id_ingrediente_1),
				t('ingrediente_repetido', { PARAM: `${ingredientes[prato.id_ingrediente_1]?.nm_ingrediente}` }));
			add(tem(set, id_ingrediente_2),
				t('ingrediente_repetido', { PARAM: `${ingredientes[prato.id_ingrediente_2]?.nm_ingrediente}` }));
		}

		if (id_proteina && proteinas && proteinas.length) {
			const set = collectUsedAttributes(dia, colunas, id_coluna, pratos, 'id_proteina');
			add(tem(set, id_proteina),
				t('proteina_repetida', { PARAM: `${proteinas[prato.id_proteina]?.nm_proteina}` }));
		}

		if (id_tipocorte && tipocorte && tipocorte.length) {
			const set = collectUsedAttributes(dia, colunas, id_coluna, pratos, 'id_tipocorte');
			add(tem(set, id_tipocorte),
				t('tipocorte_repetido', { PARAM: `${tipocorte[prato.id_tipocorte]?.nm_tipocorte}` }));
		}

		if (!id_ignora_modopreparo && id_modopreparo && modopreparo && modopreparo.length) {
			const set = collectUsedAttributes(dia, colunas, id_coluna, pratos, 'id_modopreparo', cd_tipoprato);
			add(tem(set, id_modopreparo),
				t('modopreparo_repetido', { PARAM: `${modopreparo[prato.id_modopreparo]?.nm_modopreparo}` }));
		}

		if (!id_ignora_cor && cor) {
			const set = collectUsedAttributes(dia, colunas, id_coluna, pratos, 'cor', cd_tipoprato);
			add(tem(set, cor), t('cor_repetida', { PARAM: `${prato.cor}` }));
		}

		/* restrição de combinação (a própria coluna já é ignorada) */
		const restritos = hasCombinationRestriction(dia, id_coluna, id_prato, id_grupo, cd_tipoprato, pratos, restricao_combinacao);
		restritos.forEach(r => {
			const origem = r.tipo === 'Grupo' ? grupos[r.id_grupo]?.nm_grupo : pratos[r.id_prato]?.nm_prato;
			const destino = r.tipo_comb === 'Grupo'
				? grupos[r.id_grupo_comb]?.nm_grupo
				: r.tipo_comb === 'Prato'
					? pratos[r.id_prato_comb]?.nm_prato
					: colunas[id_coluna]?.nm_tipoprato;
			add(true, t('restrito_com', { PARAM1: `${origem}`, PARAM2: `${destino}` }));
		});
	}

	/* A/B) dias adjacentes — o prato atual não está neles, então nada a descontar */
	const validarAdjacente = (diaAdj, sufixo) => {
		if (!diaAdj || id_coluna_fixa || id_intercala_pratos) return;

		if (id_ingrediente_1 || id_ingrediente_2) {
			const set = collectUsedAttributes(diaAdj, colunas, id_coluna, pratos, 'id_ingrediente', cd_tipoprato, false);
			add(tem(set, id_ingrediente_1),
				t(`ingrediente_repetido_${sufixo}`, { PARAM: `${ingredientes[prato.id_ingrediente_1]?.nm_ingrediente}` }));
			add(tem(set, id_ingrediente_2),
				t(`ingrediente_repetido_${sufixo}`, { PARAM: `${ingredientes[prato.id_ingrediente_2]?.nm_ingrediente}` }));
		}

		const setGrupo = collectUsedAttributes(diaAdj, colunas, id_coluna, pratos, 'id_grupo', cd_tipoprato, false);
		add(tem(setGrupo, id_grupo),
			t(`grupo_repetido_${sufixo}`, { PARAM: `${grupos[prato.id_grupo]?.nm_grupo}` }));
	};

	const diaAnterior = tabela[diaIndex - 1];
	if (diaAnterior?.qtde_comensais == 0) {
		add(!!prato.id_pre_preparo, t('prato_possui_pre_preparo', { PARAM: `${prato.nm_prato}` }));
	}
	validarAdjacente(diaAnterior, 'ant');
	validarAdjacente(tabela[diaIndex + 1], 'pos');

	return validations;
}
  

const serviceInstance = {
	generateScenarioEvents,
	getPlateValidations,
	getPlateUtilization,
	changeCatalogPlate,
	updateCatalogConsumption,
	updateCopiaComenais
};

export default serviceInstance;
